import { ClassificationCPC } from "./cpc-classification";
export default ClassificationCPC;
